import { FormattedMessage } from 'react-intl';
import { Flex } from '@theme-ui/components';
import { css } from '@emotion/react';

import FormattedMoney from '@app/components/FormattedMoney';
import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';
import type { ProductUpgradePrices } from '@__graphql__/types';

import messages from '../../WhatsNewForMe.messages';
import { PricesTable } from './PricesTable.styles';

const PricesTableBox = ({
  prices,
  ownedProduct,
}: {
  ownedProduct: string | null;
  prices: ProductUpgradePrices | null;
}) => {
  return (
    <Flex
      sx={{ textAlign: 'center', flexDirection: 'column', maxWidth: rem(460) }}
      px={4}
      py={2}
      mx={3}
      backgroundColor={theme.colors.lighterGray}
    >
      <PricesTable data-testid="whats-new-prices-table">
        <tbody>
          <tr
            data-table="whats-new-full-price"
            data-testid="whats-new-full-price"
          >
            <td colSpan={2}>
              <FormattedMessage {...messages.newCustomers} />
            </td>
            <td
              data-table="simple-row-full-price-value"
              data-testid="whats-new-full-price-value"
            >
              {prices?.full_price && <FormattedMoney {...prices?.full_price} />}
            </td>
          </tr>
          <tr
            data-table="whats-new-upgrade-price"
            data-testid="whats-new-upgrade-price"
          >
            <td colSpan={2}>
              <FormattedMessage
                {...messages.owners}
                values={{
                  product: (
                    <span
                      css={css`
                        white-space: nowrap;
                      `}
                    >
                      {ownedProduct}
                    </span>
                  ),
                }}
              />
            </td>
            <td
              data-table="simple-row-value"
              data-testid="whats-new-upgrade-price-value"
            >
              {prices?.upgrade_price && (
                <FormattedMoney {...prices?.upgrade_price} />
              )}
            </td>
          </tr>
          <tr
            data-table="whats-new-savings-price"
            data-testid="whats-new-savings-price"
          >
            <td colSpan={2}>
              <FormattedMessage {...messages.youSave} />
            </td>
            <td
              data-table="simple-row-value"
              data-testid="whats-new-savings-price-value"
            >
              {prices?.savings_price && (
                <FormattedMoney {...prices?.savings_price} />
              )}
            </td>
          </tr>
        </tbody>
      </PricesTable>
    </Flex>
  );
};

export default PricesTableBox;
